import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import { toastSuccess, toastError } from "../../utils/alertHelper";

export default function Registration() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    mobileNumber: "",
    gst: "",
    email: "",
  });
  const [otpDigits, setOtpDigits] = useState(["", "", "", ""]);
  const [otp, setOtp] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [otpStep, setOtpStep] = useState(false);
  const [signupData, setSignupData] = useState(null);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const payload = {
        firstName: form.firstName,
        lastName: form.lastName,
        mobileNumber: form.mobileNumber,
        email: form.email,
        business: {
          name: form.companyName,
          gstNumber: form.gst,
        },
      };

      const response = await axios.post("/api/user/signup", payload);
      if (response.data.Status === 1) {
        setSignupData(response.data);
        toastSuccess(response.data.Message || "OTP sent to your email");
        setOtpStep(true);
      } else {
        toastError(response.data.Message || "Failed to send OTP");
      }
    } catch (err) {
      toastError(err.response?.data?.Message || "Failed to send OTP");
    }
    setIsSubmitting(false);
  };

  const handleOtpDigitChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;
    const newDigits = [...otpDigits];
    newDigits[index] = value;
    setOtpDigits(newDigits);
    setOtp(newDigits.join(""));
    if (value && index < 3) {
      document.getElementById(`otp-input-${index + 1}`)?.focus();
    }
  };

  const handleOtpPaste = (e) => {
    const paste = e.clipboardData.getData("text").replace(/\D/g, "");
    if (paste.length === 4) {
      const digitsArr = paste.split("").slice(0, 4);
      setOtpDigits(digitsArr);
      setOtp(digitsArr.join(""));
      document.getElementById(`otp-input-3`)?.focus();
      e.preventDefault();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`)?.focus();
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.length < 4) return;
    setIsSubmitting(true);
    try {
      const response = await axios.post("/api/user/verifyOtp", {
        email: form.email,
        otp: otp,
      });

      if (response.data.Status === 1) {
        if (signupData?.UserToken) {
          localStorage.setItem("token", signupData.UserToken);
          localStorage.setItem("user", JSON.stringify(signupData.user));
        }

        toastSuccess("Registration successful!");

        const user = signupData?.user || response.data?.user;
        if (user?.userType === "Company") {
          localStorage.setItem("checkRole", "Company Admin");
          navigate("/user");
        } else {
          navigate("/");
        }
      } else {
        toastError(response.data.Message || "Invalid OTP");
      }
    } catch (err) {
      toastError(err.response?.data?.Message || "OTP verification failed");
    }
    setIsSubmitting(false);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f6f6f6",
        padding: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          background: "#fff",
          borderRadius: "12px",
          boxShadow: "0 5px 25px rgba(0,0,0,0.1)",
          overflow: "hidden",
          maxWidth: "900px",
          width: "100%",
        }}
      >
        {/* LEFT SIDE IMAGE */}
        <div
          style={{
            flex: "1",
            background: "#e9edf8",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          <img
            src="/front-end/images/Login/login.jpg"
            alt="Registration"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "12px 0 0 12px",
            }}
          />
        </div>

        {/* RIGHT SIDE FORM */}
        <div
          style={{
            flex: "1",
            padding: "40px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <h2
            style={{
              fontWeight: 700,
              fontSize: "1.8rem",
              marginBottom: "30px",
              color: "#333",
            }}
          >
            Registration
          </h2>

          {!otpStep ? (
            <form onSubmit={handleSendOtp} autoComplete="off">
              <div className="mb-3">
                <label style={{ color: "#666", fontSize: "0.9rem" }}>
                  First Name
                </label>
                <input
                  className="form-control"
                  name="firstName"
                  type="text"
                  value={form.firstName}
                  onChange={handleChange}
                  required
                  style={{ background: "#f4f4f6" }}
                />
              </div>

              <div className="mb-3">
                <label style={{ color: "#666", fontSize: "0.9rem" }}>
                  Last Name
                </label>
                <input
                  className="form-control"
                  name="lastName"
                  type="text"
                  value={form.lastName}
                  onChange={handleChange}
                  required
                  style={{ background: "#f4f4f6" }}
                />
              </div>

              <div className="mb-3">
                <label style={{ color: "#666", fontSize: "0.9rem" }}>
                  Company Name
                </label>
                <input
                  className="form-control"
                  name="companyName"
                  type="text"
                  value={form.companyName}
                  onChange={handleChange}
                  required
                  style={{ background: "#f4f4f6" }}
                />
              </div>

              <div className="mb-3">
                <label style={{ color: "#666", fontSize: "0.9rem" }}>
                  Mobile Number
                </label>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <span
                    style={{
                      fontSize: "1rem",
                      display: "inline-flex",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/4/41/Flag_of_India.svg"
                      alt="IN"
                      width="20"
                      style={{ marginRight: "4px" }}
                    />
                    +91
                  </span>
                  <input
                    className="form-control"
                    name="mobileNumber"
                    type="text"
                    value={form.mobileNumber}
                    onChange={handleChange}
                    required
                    style={{ background: "#f4f4f6" }}
                    maxLength={10}
                    pattern="[0-9]*"
                  />
                </div>
              </div>

              <div className="mb-3">
                <label style={{ color: "#666", fontSize: "0.9rem" }}>
                  GST Number
                </label>
                <input
                  className="form-control"
                  name="gst"
                  type="text"
                  value={form.gst}
                  onChange={handleChange}
                  required
                  style={{ background: "#f4f4f6" }}
                />
              </div>

              <div className="mb-4">
                <label style={{ color: "#666", fontSize: "0.9rem" }}>
                  Email
                </label>
                <input
                  className="form-control"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  style={{ background: "#f4f4f6" }}
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={isSubmitting}
                style={{
                  background: "#545b9e",
                  border: "none",
                  fontWeight: "500",
                }}
              >
                {isSubmitting ? "Sending..." : "Send OTP"}
              </button>
            </form>
          ) : (
            <div>
              <div className="mb-4">
                <label style={{ color: "#666", fontSize: "0.9rem" }}>Email</label>
                <input
                  className="form-control"
                  type="email"
                  value={form.email}
                  disabled
                  style={{ background: "#f4f4f6" }}
                />
              </div>

              <div style={{ textAlign: "center", marginBottom: "20px" }}>
                <p style={{ color: "#666", marginBottom: "15px" }}>
                  Enter the 4-digit OTP sent to your email
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "10px",
                    marginBottom: "20px",
                  }}
                >
                  {otpDigits.map((digit, idx) => (
                    <input
                      key={idx}
                      id={`otp-input-${idx}`}
                      type="text"
                      inputMode="numeric"
                      maxLength={1}
                      value={digit}
                      onChange={(e) => handleOtpDigitChange(idx, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(idx, e)}
                      onPaste={handleOtpPaste}
                      className="form-control"
                      style={{
                        width: "45px",
                        textAlign: "center",
                        fontSize: "22px",
                        background: "#f4f4f6",
                      }}
                      disabled={isSubmitting}
                      autoFocus={idx === 0}
                    />
                  ))}
                </div>
              </div>

              <button
                type="button"
                onClick={handleVerifyOtp}
                className="btn btn-primary w-100"
                disabled={isSubmitting || otp.length < 4}
                style={{
                  background: "#545b9e",
                  border: "none",
                  fontWeight: "500",
                  fontSize: "1rem",
                }}
              >
                {isSubmitting ? "Verifying..." : "Verify OTP"}
              </button>

              <button
                type="button"
                onClick={() => {
                  setOtpStep(false);
                  setOtpDigits(["", "", "", ""]);
                  setOtp("");
                }}
                className="btn btn-link w-100 mt-2"
              >
                Back to Registration
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
